module.exports = __webpack_public_path__ + "img/responsible-gambling-bg.715b2c12.png";